import {InputEmail} from "./ApplicationForm/InputEmail";
import {InputFirstName} from "./ApplicationForm/InputFirstName";
import {InputLastName} from "./ApplicationForm/InputLastName";
import {InputPhone} from "./ApplicationForm/InputPhone";
import {InputSalaryExpectations} from "./ApplicationForm/InputSalaryExpectations";
import {InputAvailableFrom} from "./ApplicationForm/InputAvailableFrom";
import {InputApplicationDocuments} from "./ApplicationForm/InputApplicationDocuments";
import {createForm} from "./Form/Form";
import {submitApplication} from "./Form/Helper";
import {Form} from "./Form/types";
import {__} from "@wordpress/i18n";

export const ApplicationForm = createForm(
    document.getElementById( 'application-form' ) as HTMLFormElement,
    {
        firstName: InputFirstName(document.getElementById('input-first-name')),
        lastName: InputLastName(document.getElementById('input-last-name')),
        email: InputEmail(document.getElementById('input-email')),
        phone: InputPhone(document.getElementById('input-phone')),
        salaryExpectation: InputSalaryExpectations(document.getElementById('input-salary-expectations')),
        availableFrom: InputAvailableFrom(document.getElementById('input-available-from')),
        applicationDocuments: InputApplicationDocuments( document.getElementById( 'input-application-documents' ) ),
    },
    async ( form: Form, body: FormData ): Promise<void> => {
        if ( form.validate() ) {
            const promise = await submitApplication( body );
            const response = await promise.json();
            console.log(response);

            if ( response.success ) {
                form.reset();
                form.printSuccess( __( 'Ihre Bewerbung wurde abgeschickt.', 'dierck-group-company' ) );
            }
            else {
                form.printError( response.data?.message || __( 'Es ist ein Fehler aufgetreten.', 'dierck-group-company' ) );
            }
        }
        else {
            form.printError( __( 'Korrigieren Sie Ihre eingaben.', 'dierck-group-company' ) );
        }
    }
)
